export default "__VITE_ASSET__BHrpDZFS__"